import type React from 'react';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { SimpleDropdown } from 'ui-components/components/dropdown';

import { CustomsNonDelivery } from '../../../../../../enums/customs-non-delivery';
import type { WorkflowActionInputProps } from '../../../registries/registry-types';
import { messages } from '../messages';

export const NonDeliveryDropdown: React.FC<WorkflowActionInputProps> = ({ className, draft, onUpdate }) => {
  const intl = useIntl();

  const options = useMemo(
    () => Object.values(CustomsNonDelivery).map((item) => ({ value: item.name, label: intl.formatMessage(item.translation) })),
    [intl],
  );

  return (
    <SimpleDropdown
      className={className}
      label=''
      onItemSelected={(value) => onUpdate({ parameter: value || null })}
      options={options}
      placeholder={intl.formatMessage(messages.nonDeliveryDropdownPlaceholder)}
      selectedItemValue={draft.parameter ?? ''}
    />
  );
};
